export default {
    paperGroups: [],
    paperGroupsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        isVisible: true,
        name: null
    }
}